import { Popover } from "antd";
import styled from "styled-components";

export const StyledPopover = styled(Popover)`
  padding: 0 !important;
  .ant-popover {
    background: rgba(0, 0, 0, 0.8);
  }
  &.task-eva--popover .ant-popover-inner-content {
    color: #ffffff;
  }
  .ant-popover-arrow:before {
    background: rgba(0, 0, 0, 0.8) !important;
  }
  .ant-popover-inner {
    padding: 3px 6px;
    background: rgba(0, 0, 0, 0.8) !important;
  }
`;
